import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationBaseData, ApplicationStage, ApplicationType, CustomerAppStatus } from 'common';
@Pipe({
    name: 'isApplicationsOfferVisible',
    standalone: false
})

export class IsApplicationsOfferVisiblePipe implements PipeTransform {
  transform(application: ApplicationBaseData): boolean {
    if(!application)
      return false;

    if (application.applicationType === ApplicationType.LCF || 
      application.applicationType === ApplicationType.LCP
    ) {
      return application.stage === ApplicationStage.Accepted || 
        application.stage === ApplicationStage.Approved ||
        application.stage === ApplicationStage.DirectProposal;
    }

    if(application.brokerId && !application.renewalForLoanId)
      return false;

    return application.customerFacingStatus === CustomerAppStatus.Approved;
  }
}
